<app-link
  class="i2g-logo"
  [href]="invoice2goUrl"
  [icon]="invoice2goLogo"
  [openInNewTab]="true"
>
</app-link>
<button
  i2gButton
  class="log-out-cta"
  [disabled]="loggingOut"
  (click)="onLogOutClicked()"
>
  {{ 'ACTION.LOG_OUT' | translate }}
</button>

<div class="main-container">
  <app-icon class="mail-icon" [icon]="accountBlockIcon"> </app-icon>

  <div class="title">
    {{ 'VERIFY_ACCOUNT_BLOCKED.TITLE' | translate }}
  </div>

  <strong class="user-email">{{ userEmail }}</strong>

  <span class="button-link change-email" (click)="onChangeEmailClicked()"
    >{{ 'VERIFY_ACCOUNT_BLOCKED.CHANGE_EMAIL_CTA' | translate }}
  </span>

  <span
    class="body"
    [innerHTML]="'VERIFY_ACCOUNT_BLOCKED.BODY' | translate | safe: 'html'"
  >
  </span>

  <div class="didnt-get-it">
    {{ 'VERIFY_ACCOUNT_BLOCKED.DIDNT_GET_IT' | translate }}
  </div>

  <button
    i2gButton
    class="resend-email-cta"
    [buttonStyle]="'emphasis'"
    (click)="onResendEmailClicked()"
  >
    {{ 'VERIFY_ACCOUNT_BLOCKED.RESEND_EMAIL_CTA' | translate }}
  </button>

  <div class="divider"></div>
  <div class="subtitle need-help">
    {{ 'VERIFY_ACCOUNT_BLOCKED.NEED_HELP' | translate }}
  </div>
  <app-support
    class="support"
    [isCompact]="true"
    [showFAQ]="false"
    (emailClick)="onEmailSupportClicked()"
  >
  </app-support>

  <div *ngIf="isCancelable$ | async" class="cancel-section">
    <div class="divider"></div>
    <div class="subtitle">
      {{ 'VERIFY_ACCOUNT_BLOCKED.CANCEL_TITLE' | translate }}
    </div>
    <span>
      <span>{{ 'VERIFY_ACCOUNT_BLOCKED.DONT_NEED_I2G' | translate }}</span>
      &ngsp;
      <span class="button-link" (click)="onCancelSubscription()">{{
        'VERIFY_ACCOUNT_BLOCKED.CANCEL_CTA' | translate
      }}</span>
    </span>
  </div>
  <div *ngIf="!(isSubscribedOnWeb$ | async)" class="cancel-section">
    <div class="divider"></div>
    <div class="subtitle">
      {{ 'VERIFY_ACCOUNT_BLOCKED.CANCEL_TITLE' | translate }}
    </div>
    <span *ngIf="isSubscribedOnApple$ | async">{{
      'VERIFY_ACCOUNT_BLOCKED.DONT_NEED_I2G_APPLE' | translate
    }}</span>
    <span *ngIf="isSubscribedOnGoogle$ | async">{{
      'VERIFY_ACCOUNT_BLOCKED.DONT_NEED_I2G_GOOGLE' | translate
    }}</span>
  </div>
</div>

<app-cancel-subscription-feedback-dialog
  *ngIf="isCancelable$ | async"
  [trackingScreenName]="trackingScreenName"
  [secondaryActionText]="'ACTION.BACK' | translate"
  (submitFeedback)="onCancelSubscriptionFeedbackSubmit()"
  (dismissFeedback)="dismissCancelSubscriptionFeedback()"
>
</app-cancel-subscription-feedback-dialog>

<app-cancel-subscription-offer-dialog
  *ngIf="isCancelable$ | async"
  [trackingScreenName]="trackingScreenName"
  (ctaClick)="dismissCancelSubscriptionOffer()"
>
</app-cancel-subscription-offer-dialog>
